import React, { FC } from "react";
import styled from "@emotion/styled";

const Offline = styled.p`
  color: white;
  font-size: 18px;
  text-align: center;
  padding-top: 40vh;
`;

const OfflineComp: FC<unknown> = () => <Offline> You're Offline </Offline>;
export default OfflineComp;
